/* eslint-disable no-unused-vars */
import Events from '@/events'
import {getLoadList} from "@/views/dispatchs/dispatch/api/new-index";
import BaseCache from "./cache/base-cache"

class DetailWatcher {
  constructor(rootVue) {
    this._rootVue = rootVue
    this._watchedDetailId = null
    this._registerEvents()
  }

  _registerEvents() {
    this._rootVue.$on(Events.EDIT_LOADS, (data) => {
      if (this._watchedDetailId === data.id) {
        this._rootVue.$store.dispatch('dispatch/getTaskList', data.id)
      }
    })
  }

  watchDetail(id) {
    this._watchedDetailId = parseInt(id)
  }
}

class ListWatcher {
  constructor(rootVue, loadService) {
    this._loadService = loadService
    this._rootVue = rootVue
    this._watchedListArgs = null
    this._cb = null
    this._registerEvents()
  }

  _registerEvents() {
    this._rootVue.$on([Events.EDIT_LOADS, Events.NEW_LOADS, Events.DELETE_LOADS], (event, data) => {
      if (this._watchedListArgs) {
        setTimeout(() => {
          console.debug('LoadsListWatcher', 'refreshed')
          const data = this._loadService.getList(...this._watchedListArgs)
          if (this._cb) {
            this._cb(data)
          }
        })
      }
    })
  }

  watchList(...args) {
    console.debug('LoadsListWatcher: set', args)
    this._watchedListArgs = args
  }
  setCallback(cb) {
    this._cb = cb
  }
  cancelWatchList() {
    console.debug('LoadsListWatcher: clear')
    this._watchedListArgs = null
    this._cb = null
  }
}

class LoadService {
  constructor(rootVue) {
    this._rootVue = rootVue
    this._detailWatcher = null
    this._listWatcher = null
    this._m_listCache = null
  }

  get detailWatcher() {
    if (!this._detailWatcher) {
      this._detailWatcher = new DetailWatcher(this._rootVue)
    }
    return this._detailWatcher
  }

  get listWatcher() {
    if (!this._listWatcher) {
      this._listWatcher = new ListWatcher(this._rootVue, this)
    }
    return this._listWatcher
  }

  get _listCache() {
    if (!this._m_listCache) {
      this._m_listCache = new BaseCache({
          func: getLoadList,
          events: [Events.EDIT_LOADS, Events.NEW_LOADS, Events.DELETE_LOADS],
          formatResult: true
        })
    }
    return this._m_listCache
  }

  getList(pages, params) {
    return this._listCache.getData(pages, params)
  }
}

//commit("dispatch/GET_TASK_DETAIL", resp.res.data.data)
let instance = null

export function loadServerInit($bus) {
  instance = new LoadService($bus)
}

export function getLoadServerInstance() {
  return instance
}

